import { reactive } from 'vue';

interface ToastState {
  isVisible: boolean;
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
  duration: number;
}

const toastState = reactive<ToastState>({
  isVisible: false,
  message: '',
  type: 'info',
  duration: 3000,
});

export function useToast() {
  const show = (message: string, type = 'info', duration = 3000) => {
    toastState.message = message;
    toastState.type = type as any;
    toastState.duration = duration;
    toastState.isVisible = true;
  };

  const success = (message: string) => show(message, 'success');
  const error = (message: string) => show(message, 'error');
  const warning = (message: string) => show(message, 'warning');
  const info = (message: string) => show(message, 'info');

  return { toastState, show, success, error, warning, info };
}
